module.exports = __webpack_public_path__ + "img/Palintonon64_ua.f9993cb8.webp";